// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"Q2URC","historyCard":"_1auI_","card":"_1ayPO","cardImgWrapper":"_2-w-I","titlebox":"toXUr","cardText":"_3m7f2"};